const RightSideInfoCard = ({ title, description, image }) => {
  return (
    <div>
      <div className="flex items-start gap-4">
        <img
          src={image}
          alt={title}
          className="w-full h-48 object-contain rounded-lg mb-4"
        />
      </div>
      <h3 className="font-semibold text-center text-text-primary text-lg mb-2">
        {title}
      </h3>
      <p className="text-sm text-center text-text-secondary leading-relaxed">
        {description}
      </p>
    </div>
  );
};
export default RightSideInfoCard;
